import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken, primitive } from 'styles/constants';

export const Container = Box.withConfig({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '1',
  fontSize: 'md',
  color: primitive.$bbqBrown,
  fontWeight: 'normal',
  lineHeight: '1.1',
});

export const Price = withTypography({ m: '$0', color: getDesignToken('color-validated') });

export const GreyStyledText = withTypography({ m: '$0', color: primitive.$greySix });

export const Divider = withTypography({ my: '$0', color: primitive.$greyTwo, mx: '$1' });
